// istanbul ignore file -- all submodules are tested
import { useToken } from '@ori/auth';
import { TranslationsNamespaceProvider } from '@ori/i18n';
import { LoggerProvider } from '@ori/logger';
import { Team, TestIdProvider } from '@ori/testid-generator';
import type { FC } from 'react';

import { AppPromoBanner, ShadePicker } from '../components';
import { translationsNamespace } from '../constants';
import { AppConfigProvider } from '../context';
import { mainLogger } from '../logger';
import { Content } from './Content';
import { Context } from './Context';
import { Pbs } from './Pbs';
import type { TopAreaProps } from './types';

export const TopArea: FC<TopAreaProps> = ({ configuration, ...pbs }) => {
  const { token } = useToken();

  if (!token) {
    return null;
  }

  return (
    <TranslationsNamespaceProvider namespace={translationsNamespace}>
      <AppConfigProvider value={configuration}>
        <TestIdProvider
          team={Team.Presentation}
          project="top-area"
        >
          <LoggerProvider logger={mainLogger}>
            <Context>
              <AppPromoBanner />
              <Pbs {...pbs}>
                <Content />
              </Pbs>
              <ShadePicker />
            </Context>
          </LoggerProvider>
        </TestIdProvider>
      </AppConfigProvider>
    </TranslationsNamespaceProvider>
  );
};
